// extracted by mini-css-extract-plugin
module.exports = {"light":"#EAE9E8","timeline":"TimelineGraph_timeline__1qCcR","yGrid":"TimelineGraph_yGrid__3Sxz4"};